import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	core: {
		skeletonLoaders: {
			variables: [
				{
					key: 'fillColor',
					value: '#dddddd',
				},
			],
			loaders: [
				{
					id: 'ksys-app-start',
					breakpoints: [
						{
							minWidthInPixels: 0,
							style: {
								height: '86px',
							},
							children: [
								{
									fill: '{fillColor}',
									x: '0px',
									y: '11.90625px',
									height: '28px',
									width: '100%',
								},
								{
									fill: '{fillColor}',
									x: '0px',
									y: '59.8125px',
									height: '18px',
									width: '100%',
								},
							],
						},
					],
				},
			],
		},
	},
	components: {
		app: {},
		awards: {
			awardQueries: {
				awards: {
					code: 'performance_annual_returns',
					entityType: 'CLSS',
					queryOptionsType: 'statistics',
				},
				description: {
					queryOptionsType: 'none',
					value:
						'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse id tortor tristique, posuere massa sed, imperdiet id aliquet nisi augue a dolor. Fusce vitae dapibus quam, et efficitur arcu...',
				},
				layout: 'name-first',
				// Award name is used for the alt attribute of images. Making the image accessible
				name: {
					format: {
						options: {
							placeholderText: 'Award {value}',
						},
					},
					key: 'label',
					queryOptionsType: 'statistic',
				},
				order: {
					key: 'label',
					queryOptionsType: 'statistic',
				},
				photoSrc: {
					queryOptionsType: 'none',
					subQueries: [
						{
							key: 'label',
							queryId: 'code',
							queryOptionsType: 'statistic',
						},
					],
					value: 'https://cdn.theorg.com/0c0a9d58-f26c-4d59-93c8-6af7c363042b_medium.jpg',
				},
			},
			props: {
				hideAwardsWithNoImages: true,
				textProps: {
					hasHtmlContent: false,
					toggleState: 'collapsed',
					collapse: {
						maxLength: 100,
						suffix: '...',
					},
				},
			},
			queries: {},
		},
		card: {
			props: {},
			queries: {
				subtitle: {
					code: 'launch_date',
					entityType: 'CLSS',
					format: {
						options: {
							day: '2-digit',
							month: '2-digit',
							placeholderText: 'as at {value}',
							year: '2-digit',
						},
					},
					placeholder: '',
					queryOptionsType: 'property',
				},
				title: {
					queryOptionsType: 'fundManagers',
					value: 'Awards',
				},
			},
		},
		disclaimers: {
			props: {
				disclaimers: [],
				hasHtmlContent: true,
			},
			queries: {
				disclaimers: [
					{
						text: {
							key: 'Performance Disclaimer',
							queryOptionsType: 'disclaimers',
						},
					},
				],
			},
		},
	},
	assetOverrides: {
		base: {
			carousel: {
				navLeft: 'CarouselNavArrowLeftIcon.svg',
				navRight: 'CarouselNavArrowRightIcon.svg',
			},
		},
	},
};
